var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',[_c('BottomHeader',{attrs:{"is-mobile-view":_vm.checkIsMobileView}}),_c('TopHeader',{attrs:{"is-mobile-view":_vm.checkIsMobileView}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }